module.exports = __webpack_public_path__ + "static/20-2b55f453b0b0429d8670b9d067af7c77.png";